// extracted by mini-css-extract-plugin
export default {"tag-container":"JournalItemPage_tag-container__Z74x3","project-button":"JournalItemPage_project-button__0O7zu","no-margin":"JournalItemPage_no-margin__Ix7U-"};